import { useContext } from "react"
import styled from "styled-components"
import dynamic from "next/dynamic"
import Actions from "scenes/CarScene/Actions"
import CarCTA from "scenes/CarScene/MobileCTA"
import CarImages from "scenes/CarScene/CarImages"
import TagsAndPromos from "scenes/CarScene/TagsAndPromos"
import { FullRow } from "components/styled/Grid"
import { color } from "helpers/styled"
import { CarContext } from "scenes/CarScene/CarContext"
import { SliderContextProvider } from "./SliderContext"

const PanoramaOverlay = dynamic(() => import("scenes/CarScene/PanoramaOverlay"))

const WhiteBackground = styled(FullRow)`
  position: relative;
  z-index: -1;

  &:before {
    content: "";
    position: absolute;
    width: 100vw;
    height: 100vh;
    left: 0;
    right: 0;
    bottom: 150px;
    background-color: ${color("paleGray")};
  }
`

const MediaWrapper = styled.div`
  position: relative;
`

export default function Header() {
  const {
    page,
    car: { panoramaConfig }
  } = useContext(CarContext)

  return (
    <SliderContextProvider page={page}>
        <MediaWrapper>
          <TagsAndPromos />
          <CarImages />
          {panoramaConfig?.enabled && <PanoramaOverlay />}
        </MediaWrapper>
        <WhiteBackground />
        <Actions />
        <CarCTA />
      </SliderContextProvider>
  )
}
